import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './Partners.css';
import doLogo from '../../assets/images/digital-ocean.webp';
import zohoLogo from '../../assets/images/zoho.webp';
import ctrlLogo from '../../assets/images/ctrl-booking.webp';
import tgBadge from '../../assets/images/tg-badge.webp';

const Partners = () => {
  const partners = [
    {
      id: 1,
      name: 'DigitalOcean',
      image: doLogo,
      link: 'https://digitalocean.com',
      className: 'partner-logo'
    },
    {
      id: 2,
      name: 'Ctrl',
      image: ctrlLogo,
      link: 'https://wordpress.org/plugins/ctrl-booking-system/',
      className: 'partner-logo ctrl-logo'
    },
    {
      id: 3,
      name: 'Zoho',
      image: zohoLogo,
      link: 'https://zoho.eu',
      className: 'partner-logo zoho-logo'
    },
    {
      id: 4,
      name: 'TG',
      image: tgBadge,
      link: '#',
      className: 'partner-logo tg-logo'
    }
  ];

  const [centerSlidePercentage, setCenterSlidePercentage] = useState(33.33);

  useEffect(() => {
    const updateCarouselSettings = () => {
      if (window.innerWidth <= 768) { // Mobile
        setCenterSlidePercentage(100);
      } else if (window.innerWidth <= 1024) { // Tablet
        setCenterSlidePercentage(50);
      } else { // Desktop
        setCenterSlidePercentage(33.33);
      }
    };

    updateCarouselSettings(); // Set initial value
    window.addEventListener('resize', updateCarouselSettings);

    return () => {
      window.removeEventListener('resize', updateCarouselSettings);
    };
  }, []);

  return (
    <section id="partners" className="partners section">
      <div className="container">
        <motion.div
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>Our Partners</h2>
        </motion.div>
        
        <motion.div
          className="partners-carousel"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Carousel
            showArrows={true}
            showStatus={false}
            showThumbs={false}
            infiniteLoop={true}
            autoPlay={true}
            interval={3000}
            centerMode={true}
            centerSlidePercentage={centerSlidePercentage}
            onClickItem={(index, item) => {
              window.open(partners[index].link, '_blank');
            }}
          >
            {partners.map((partner) => (
              <div key={partner.id} className="carousel-item">
                <img src={partner.image} alt={partner.name} className={partner.className} />
              </div>
            ))}
          </Carousel>
        </motion.div>
      </div>
    </section>
  );
};

export default Partners;
